
/** npm import */
import React from 'react'
import { useNavigate } from 'react-router';

/** local file import */
import Header from '../Layout/header'



/** code start */

const Faq = () => {



    return (
        <>
            <Header />

            <section className='custom_section'>
                <div className='container py-4 py-md-5'>
                    <div className='faq_section'>
                        <h2 className='color-brand-1 mb-4 mb-md-5'>Faq</h2>



                        <div className='faq_cms_section'>
                            <h5>What is Lorem Ipsum ?</h5>
                            <p>Lorem ipsum dolor sit amet,
                                consectetur adipiscing elit,
                                sed do eiusmod tempor incididunt ut
                                labore et dolore magna aliqua. Ut enim
                                ad minim veniam, quis nostrud exercitation
                                ullamco laboris nisi ut aliquip ex ea commodo
                                consequat. Duis aute irure dolor in reprehenderit in
                                voluptate velit esse cillum dolore eu fugiat nulla
                                pariatur. Excepteur sint occaecat cupidatat non proident,
                                sunt in culpa qui officia deserunt mollit anim id est
                                laborum.</p>
                            <h5>What is Lorem Ipsum ?</h5>
                            <p>Lorem ipsum dolor sit amet,
                                consectetur adipiscing elit,
                                sed do eiusmod tempor incididunt ut
                                labore et dolore magna aliqua. Ut enim
                                ad minim veniam, quis nostrud exercitation
                                ullamco laboris nisi ut aliquip ex ea commodo
                                consequat. Duis aute irure dolor in reprehenderit in
                                voluptate velit esse cillum dolore eu fugiat nulla
                                pariatur. Excepteur sint occaecat cupidatat non proident,
                                sunt in culpa qui officia deserunt mollit anim id est
                                laborum.</p>
                            <h5>What is Lorem Ipsum ?</h5>
                            <p>Lorem ipsum dolor sit amet,
                                consectetur adipiscing elit,
                                sed do eiusmod tempor incididunt ut
                                labore et dolore magna aliqua. Ut enim
                                ad minim veniam, quis nostrud exercitation
                                ullamco laboris nisi ut aliquip ex ea commodo
                                consequat. Duis aute irure dolor in reprehenderit in
                                voluptate velit esse cillum dolore eu fugiat nulla
                                pariatur. Excepteur sint occaecat cupidatat non proident,
                                sunt in culpa qui officia deserunt mollit anim id est
                                laborum.</p>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Faq